import React from 'react'
import PropTypes from 'prop-types'

class AddressInfo extends React.PureComponent {
  render() {
    if (this.props.address) {
      return (
        <>
          <div>{this.props.address.name.full}</div>
          <div>{this.props.address.addressRow1}</div>
          <div>{this.props.address.addressRow2}</div>
          <div>
            {this.props.address.postalCode} {this.props.address.postalArea}
          </div>
        </>
      )
    }

    return null
  }
}

AddressInfo.propTypes = {
  address: PropTypes.object,
}

AddressInfo.defaultProps = {
  address: null,
}

export default AddressInfo
